module.exports = __webpack_public_path__ + "static/media/image1.fd919a25.jpg";